module.exports = __webpack_public_path__ + "assets/7b14b20709a59654bcdd54404e2b630e.png";